import UtilityService from '../services/utility.service';
import DataService from '../services/data.service';

export class NavBarComponent {
    constructor() {
        this.componentName = "navBarComponent";
        this.template = `
    <nav class="navbar navbar-expand-md navbar-dark bg-dark fixed-top">
      <a class="navbar-brand" onClick="_cmp.main.render()" href="javascript:void(0)">ChemDrill Admin</a>
      <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExampleDefault" aria-controls="navbarsExampleDefault" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>
    
      <div class="collapse navbar-collapse" id="navbarsExampleDefault">
        <ul class="navbar-nav mr-auto">
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.main.render()" href="javascript:void(0)">Home</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.polyatomicAnions.render()" href="javascript:void(0)">Polyatomic Anions</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.solubilityRules.render()" href="javascript:void(0)">Solubility Rules</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.solubilityQuiz.render()" href="javascript:void(0)">Solubility Quiz</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.nomenclatureQuiz.render()" href="javascript:void(0)">Nomenclature Quiz</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.elements.render()" href="javascript:void(0)">Elements</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.render(); _cmp.visitors.render()" href="javascript:void(0)">Visitors</a>
          </li>
          <li class="nav-item active">
            <a class="nav-link" onClick="_cmp.navBar.logout()" href="javascript:void(0)">Log Out</a>
          </li>
        </ul>
      </div>
    </nav>
    `;
    }

	render() {
		if (localStorage.getItem("token")) {
			this.show();
		}
	}
	
	show() {
		_svc.util.html("#" + this.componentName, this.template);
	}
	
	hide() {
		_svc.util.clear("#" + this.component);
	}
	
	logout(){
		_svc.util.clear("#" + this.componentName);
		localStorage.clear();
		_cmp.main.render();
	}
}

setTimeout(function(){_cmp.navBar = new NavBarComponent();}, 1);